module.exports = __webpack_public_path__ + "static/media/SCBbag.ec9deb1c.svg";